import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const NcdEntitlement = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        NCD Entitlement
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="ncdEntitlement"
              onChange={props.handleChangeEcdEntitlement}
              value={props.defaultEcdEntitlement}
              required
            >
              <option value="">Please select</option>
              <option value="0">0</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="60">60</option>
            </select>
      </Col>
    </FormGroup>
  )
}

NcdEntitlement.propTypes = {
  handleChangeEcdEntitlement: PropTypes.func,
  defaultEcdEntitlement: PropTypes.string,

};

export default NcdEntitlement;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/ncdEntitlement/NcdEntitlement.js